<template>
    <div class="min-h-screen bg-gray-100">
        <!-- Barra de Navegação Simples -->
        <nav class="bg-indigo-600 shadow-sm">
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div class="flex justify-between h-16">
                    <div class="flex">
                        <div class="flex-shrink-0 flex items-center">
                            <span class="text-white font-bold text-xl">Portal Justech</span>
                        </div>
                        <div class="hidden sm:-my-px sm:ml-6 sm:flex sm:space-x-8">
                            <router-link to="/portal-cliente/perfil" class="text-white inline-flex items-center px-1 pt-1 border-b-2 font-medium" :class="[ $route.name === 'ClientePerfil' ? 'border-white' : 'border-transparent opacity-75 hover:opacity-100 hover:border-white' ]">Meu Perfil</router-link>
                            <router-link to="/portal-cliente/historico" class="text-white inline-flex items-center px-1 pt-1 border-b-2 font-medium" :class="[ $route.name === 'ClienteHistorico' ? 'border-white' : 'border-transparent opacity-75 hover:opacity-100 hover:border-white' ]">Histórico</router-link>
                            <router-link to="/portal-cliente/solicitacoes" class="text-white inline-flex items-center px-1 pt-1 border-b-2 font-medium" :class="[ $route.name === 'ClienteSolicitacoes' ? 'border-white' : 'border-transparent opacity-75 hover:opacity-100 hover:border-white' ]">Solicitações</router-link>
                        </div>
                    </div>
                    <div class="hidden sm:ml-6 sm:flex sm:items-center">
                        <button @click="logout" class="bg-indigo-700 p-2 rounded text-white hover:bg-indigo-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-indigo-800 focus:ring-white">
                            Sair
                        </button>
                    </div>
                </div>
            </div>
        </nav>

        <!-- Conteúdo das Views Filhas -->
        <main class="py-10">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <router-view></router-view>
            </div>
        </main>
    </div>
</template>

<script>
export default {
    name: 'ClienteMainDashView',
    methods: {
        logout() {
            window.localStorage.removeItem('myClientUser');
            this.$router.push({ name: 'ClienteLogin' });
        }
    }
}
</script>
